import { Injectable } from '@angular/core';

/**
 * Token Service
 * Centralized service for handling access tokens across the application.
 * Always fetches fresh token from cookie to avoid stale token issues after session refresh.
 */
@Injectable({
  providedIn: 'root'
})
export class TokenService {

  /**
   * Gets the fresh access token directly from the cookie.
   * This ensures we always use the latest token even after session refresh.
   * @returns The current access token from cookie, or empty string if not found
   */
  getAccessToken(): string {
    const name = 'ACCESS_TOKEN=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');

    for (const cookie of cookies) {
      const trimmedCookie = cookie.trim();
      if (trimmedCookie.startsWith(name)) {
        return trimmedCookie.substring(name.length).replace(/^"(.+(?="$))"$/, '$1');
      }
    }
    return '';
  }
}

